import * as _ from 'lodash'

class Response {
    constructor(response) {
        this.response = response
    }

    getData() {
        let response = this.response
        let data

        if (_.has(response, 'data.data')) {
            data = response.data.data

            // If data is an array we can safely assume it's a collection of objects
            // Therefore return array
            if (Array.isArray(data)) {
                return response.data
            }

            // A data.data type of object signals that this is a singular entity
            // Therefore we just return the plain object
            if (typeof data === 'object') {
                return data
            }
        }

        // Default to plain response
        return response.data
    }

    getPagination() {
        return _.get(this.response, 'data.meta', false)
    }

    getStatus() {
        return _.get(this.response, 'status')
    }

    getHeaders() {
        return _.get(this.response, 'headers', {})
    }

    getValidationErrors() {
        return _.get(this.response, 'data', null)
    }
}

export default Response
